type ObjType = { [key: string]: NonNullable<any> }


import md5 from '@/common/js/md5.js'

import { useComDataStore } from '@/store'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'

// 缓存 comReqData 的引用，首次调用时读取并缓存，后续复用，避免每次调用都创建新的 ref
let _cachedComReqData: Ref<any> | null = null
function getComReqData(): Ref<any> {
    if (!_cachedComReqData) {
        const store = useComDataStore()
        _cachedComReqData = storeToRefs(store).comReqData
    }
    return _cachedComReqData as Ref<any>
}








/**
 * @param queryObj 签名
 * @param noMd5 
 * @returns 
 */
export const querySort = (queryObj: ObjType, key?: string): string => {
    // 过滤掉 sign 字段，排序 key
    const keyArr = Object.keys(queryObj).filter(key => key !== 'sign').sort();
    // 拼接参数字符串，忽略值为 null、undefined、''，但保留 0
    const str = keyArr
        .filter(key => queryObj[key] !== undefined && queryObj[key] !== null && queryObj[key] !== '')
        .map(key => `&${key}=${queryObj[key]}`)
        .join('');
    // 去掉第一个 &，返回 md5 或原串
    const result = str.startsWith('&') ? str.slice(1) : str;
    const sign = `${result}&${key || ''}`
    return md5(sign)
}


/**
 * 对象添加sign
 * @param obj 要添加签名的对象
 * @returns 
 */


export const addSign = <T extends ObjType>(obj: T): T & { sign: string } => {
    if (obj.debugger) {
        delete obj.debugger
    }
    // 公共参数
    // 使用缓存的 comReqData ref，避免每次调用都执行 storeToRefs
    const comReqDataRef = getComReqData()
    // console.log(comReqDataRef.value, '======value')
    const commonData = {
        ...((comReqDataRef && comReqDataRef.value) || {}),
        ...obj,
        tm: Date.now() / 1000 | 1,
    }
    const sign = querySort(commonData)
    const data = {
        ...commonData,
        sign
    }

    return data
}


